export default "/static/media/spring.850befa0.css";